import {
  ONBOARDING_ACTIONS,
  ONBOARDING_GETTERS,
  ONBOARDING_CONFIG,
} from './onboarding';
import {
  PAYMENTS_ACTIONS,
  PAYMENTS_GETTERS,
  PAYMENTS_CONFIG,
} from './payments';

export const ACTIONS = {
  ...ONBOARDING_ACTIONS,
  ...PAYMENTS_ACTIONS,
};

export const GETTERS = {
  ...ONBOARDING_GETTERS,
  ...PAYMENTS_GETTERS,
};

export const CONFIGS = {
  ...ONBOARDING_CONFIG,
  ...PAYMENTS_CONFIG,
};
